import fetch from "../../../core/fetch";
import showToaster from "../../../helpers/showToaster";
import { containsMalicious } from "../../../helpers/textRestriction";

async function submit(values, dispatch) {
  const { faqItems = [], faqsDescription = "", listId } = values;
  // Validate each text field
  for (const item of faqItems) {
    const title = item?.title?.trim() || "";
    const content = item?.content?.trim() || "";

    // Rule 1 & 2: Both title and content must be present (non-empty after trim)
    const hasTitle = title !== "";
    const hasContent = content !== "";

    if ((hasTitle && !hasContent) || (!hasTitle && hasContent)) {
      showToaster({
        messageId: "invalidInput",
        toasterType: "error",
      });
      return;
    }

    // Rule 3: Check for malicious content in title/content if they exist
    if (
      (hasTitle && containsMalicious(title)) ||
      (hasContent && containsMalicious(content))
    ) {
      showToaster({ messageId: "invalidInput", toasterType: "error" });
      return;
    }
  }

  const query = `
    mutation ($faqItems: [FaqInputType], $faqsDescription: String, $listId: Int) {
      updateHostListingWebsiteFaq(faqItems: $faqItems, faqsDescription: $faqsDescription, listId: $listId) {
        status
      }
    }
  `;

  const variables = {
    faqItems: faqItems.map((item) => ({
      id: item.id || undefined,
      title: item.title,
      content: item.content,
    })),
    faqsDescription,
    listId,
  };

  const resp = await fetch("/graphql", {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query,
      variables,
    }),
    credentials: "include",
  });
  const response = await resp.json();
  const { data } = response;
  if (data?.updateHostListingWebsiteFaq?.status === 200) {
    showToaster({ messageId: "updateFaq", toasterType: "success" });
    window.location.href = "/siteadmin/faqs";
  } else {
    showToaster({ messageId: "updateFaqError", toasterType: "error" });
  }
}

export default submit;
